'use client';

import { useEffect } from 'react';

/**
 * Component to handle browser extension attributes that cause hydration mismatches
 * This runs only on the client side to clean up any attributes added by browser extensions
 */
export function HydrationGuard() {
    useEffect(() => {
        // Remove common browser extension attributes that cause hydration mismatches
        const body = document.body;
        const attributesToRemove = [
            'data-new-gr-c-s-check-loaded',
            'data-gr-ext-installed',
            'data-new-gr-c-s-loaded',
            'cz-shortcut-listen',
        ];

        attributesToRemove.forEach((attr) => {
            if (body.hasAttribute(attr)) {
                body.removeAttribute(attr);
            }
        });

        // Also handle any dynamically added attributes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.target === body) {
                    attributesToRemove.forEach((attr) => {
                        if (body.hasAttribute(attr)) {
                            body.removeAttribute(attr);
                        }
                    });
                }
            });
        });

        observer.observe(body, { attributes: true });

        return () => observer.disconnect();
    }, []);

    return null;
}
